import { z } from 'zod';

import { apiClient } from './client';

/**
 * Временная загрузка фото -> готовый S3-путь.
 *
 * Клиент грузит файл сюда, получает `path`, и кладёт его в `photo_paths` ДО
 * создания сущности (backend ждёт строки-пути, не multipart-файлы).
 * Backend: POST /api/uploads/temp (multipart `file`).
 */
const TempUploadZ = z.object({
  data: z.object({
    path: z.string(),
    url: z.string().nullable(),
    uploaded_at: z.string(),
  }),
});

export async function uploadTempPhoto(file: File): Promise<string> {
  const form = new FormData();
  form.append('file', file);
  const res = await apiClient.post('/uploads/temp', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return TempUploadZ.parse(res.data).data.path;
}
